export type LegalDoc = {
  id: 'privacy' | 'terms'
  label: string
  title: string
  updated: string
  sections: { heading: string; body: string[] }[]
}

export const legalDocs: Record<LegalDoc['id'], LegalDoc> = {
  privacy: {
    id: 'privacy',
    label: 'Política de Privacidad',
    title: 'Política de Privacidad',
    updated: 'Última actualización: enero 2026',
    sections: [
      {
        heading: '1. Información que recopilamos',
        body: [
          'Recopilamos únicamente los datos necesarios para entregarte el producto digital: tu nombre y tu correo electrónico al momento de la compra, además de los datos técnicos que genera tu navegador (dirección IP, tipo de dispositivo y páginas visitadas).',
          'El pago se procesa por una plataforma externa de pagos. Nosotros no almacenamos ni tenemos acceso a los números completos de tu tarjeta.',
        ],
      },
      {
        heading: '2. Cómo usamos tus datos',
        body: [
          'Usamos tu correo electrónico para enviarte el acceso a la guía digital, los materiales incluidos en tu compra y avisos relacionados con actualizaciones del protocolo.',
          'Los datos técnicos se usan de forma agregada para entender qué secciones de la página resultan útiles y mejorar el contenido.',
        ],
      },
      {
        heading: '3. Datos de salud',
        body: [
          'No te pedimos, ni necesitamos, tu historial médico ni diagnósticos. Cualquier información sobre tu dolor o condición que decidas compartir voluntariamente no se vende ni se comparte con terceros.',
        ],
      },
      {
        heading: '4. Cookies y tecnologías similares',
        body: [
          'Utilizamos cookies propias y de terceros para medir el rendimiento de la página y atribuir compras. Puedes bloquear o eliminar las cookies desde la configuración de tu navegador; la guía seguirá funcionando con normalidad.',
        ],
      },
      {
        heading: '5. Con quién compartimos información',
        body: [
          'Compartimos datos solo con los proveedores que hacen posible la entrega: la plataforma de pagos, el servicio de envío de correos y el alojamiento de archivos. Cada uno accede exclusivamente a lo mínimo necesario para su función.',
          'Nunca vendemos, alquilamos ni intercambiamos tus datos personales.',
        ],
      },
      {
        heading: '6. Conservación y seguridad',
        body: [
          'Conservamos tus datos de compra mientras sea necesario para dar soporte al acceso del producto y cumplir con obligaciones fiscales. Aplicamos cifrado en tránsito y acceso restringido a los registros.',
        ],
      },
      {
        heading: '7. Tus derechos',
        body: [
          'Puedes solicitar el acceso, la corrección o la eliminación de tus datos personales, así como darte de baja de nuestros correos con el enlace de cancelación incluido en cada mensaje. Las solicitudes de eliminación se procesan en un plazo de 30 días.',
        ],
      },
      {
        heading: '8. Menores de edad',
        body: [
          'Este producto está dirigido a personas mayores de 18 años. No recopilamos de forma intencional información de menores.',
        ],
      },
    ],
  },
  terms: {
    id: 'terms',
    label: 'Términos y Condiciones',
    title: 'Términos y Condiciones',
    updated: 'Última actualización: enero 2026',
    sections: [
      {
        heading: '1. Naturaleza del producto',
        body: [
          'El Protocolo de Rescate Lumbar es un producto digital de carácter educativo, entregado en formato PDF y accesible de inmediato tras la compra. No incluye sesiones en vivo, terapia presencial ni seguimiento clínico individual.',
        ],
      },
      {
        heading: '2. Aviso médico',
        body: [
          'El contenido no constituye diagnóstico, tratamiento ni consejo médico, y no sustituye la evaluación de un profesional de la salud. Consulta a tu médico antes de comenzar cualquier rutina de posiciones o ejercicios, especialmente si tienes una condición diagnosticada.',
          'Interrumpe el uso del protocolo y busca atención inmediata si presentas pérdida de control de esfínteres, debilidad progresiva en las piernas, fiebre con dolor de espalda o una fractura reciente.',
        ],
      },
      {
        heading: '3. Sin garantía de resultados',
        body: [
          'Los resultados descritos corresponden a experiencias reportadas por usuarios y no son una promesa individual. Tu progreso depende de tu condición particular, la constancia con la que apliques el protocolo y otros factores que están fuera de nuestro control.',
        ],
      },
      {
        heading: '4. Licencia de uso',
        body: [
          'Con tu compra recibes una licencia personal, intransferible y no exclusiva para usar los materiales. Queda prohibido revender, redistribuir, publicar, traducir o reproducir el contenido, total o parcialmente, sin autorización escrita.',
        ],
      },
      {
        heading: '5. Precio y pago',
        body: [
          'El precio es un pago único de $19 USD, sin suscripción, cargos recurrentes ni renovaciones automáticas. El acceso se entrega de forma digital inmediatamente después de confirmarse el pago.',
        ],
      },
      {
        heading: '6. Política de reembolso',
        body: [
          'Por tratarse de un producto digital de descarga inmediata, las solicitudes de reembolso se evalúan caso por caso dentro de los primeros 14 días posteriores a la compra, a través del mismo canal en el que se realizó el pago.',
        ],
      },
      {
        heading: '7. Uso responsable',
        body: [
          'Te comprometes a aplicar las posiciones dentro de tu rango de tolerancia, a detenerte si el dolor aumenta y a respetar la lista de "banderas rojas" incluida en la guía. Asumes la responsabilidad de cómo utilizas la información.',
        ],
      },
      {
        heading: '8. Limitación de responsabilidad',
        body: [
          'En la máxima medida permitida por la ley, nuestra responsabilidad se limita al monto pagado por el producto. No respondemos por daños indirectos derivados del uso o de la imposibilidad de uso de los materiales.',
        ],
      },
      {
        heading: '9. Cambios en los términos',
        body: [
          'Podemos actualizar estos términos para reflejar mejoras en el producto o requisitos legales. La versión vigente será siempre la publicada en esta página.',
        ],
      },
    ],
  },
}
